import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Message1 = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M8.886 2.11c-3.817 0-6.95 2.631-6.95 5.93s3.133 5.93 6.95 5.93l.347-.01a8 8 0 0 0 1.028-.116l.051-.011-.229-.181a7.4 7.4 0 0 0 2.634 1.403.87.87 0 0 0 .99-1.292l-.155-.277a6 6 0 0 1-.261-.585l-.068-.194.201-.136a5.76 5.76 0 0 0 2.412-4.513c0-3.317-3.132-5.948-6.95-5.948m0 1.2c3.197 0 5.75 2.145 5.75 4.73a4.55 4.55 0 0 1-2.403 3.861.6.6 0 0 0-.299.674l.087.316q.096.315.22.618l.048.111-.113-.05a6.2 6.2 0 0 1-1.326-.842.6.6 0 0 0-.516-.123 6.8 6.8 0 0 1-1.45.165c-3.195 0-5.748-2.145-5.748-4.73s2.553-4.73 5.75-4.73"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Message1$1 = Svg18Message1;

export { Svg18Message1$1 as default };
